module.exports = __webpack_public_path__ + "static/img/refuse.b44e2818.png";